import { login } from "firebase_/firebase_function/firebase_user";
import Cookies from "js-cookie";
import { createContext, use, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { emptyCheck } from "util/function/function";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState({});
  const [blockData, setBlockData] = useState({});
  const navigate = useNavigate();

  // useEffect(() => {
  //   const localUserData = sessionStorage.getItem("userData");
  //   if (emptyCheck(localUserData)) {
  //     navigate("/"); // 로그인 페이지로 이동
  //     console.log("localUserData 없음");
  //   }
  // });

  useEffect(() => {
    /// ✅ DEV ONLY — 로컬(localhost)에서 디자인 렌더링용 목업 유저 자동 주입
    const isLocalhost =
      process.env.NODE_ENV === "development" &&
      (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1");

    if (isLocalhost) {
      let devMock = sessionStorage.getItem("__devMockUser");
      if (!devMock) {
        // 기본 목업 유저(농가) — URL 파라미터로 role=expert 주면 수리기사
        const params = new URLSearchParams(window.location.search);
        const role = params.get("role") === "expert" ? "수리기사" : "농가";
        const mock = {
          docId: "dev-mock-doc",
          id: role === "수리기사" ? "dev-expert-id" : "dev-farmer-id",
          name: role === "수리기사" ? "김기사" : "이창주",
          phone: "01000000000",
          address: "대전 유성구",
          addressDetail: "테스트",
          userType: role,
          material: "벼, 한우",
          point: "12000",
          rating: "4.8",
          token: "",
          createDate: "2026-01-01 00:00",
          deleteDate: null,
          lastLogin: new Date().toISOString().slice(0, 19).replace("T", " "),
        };
        devMock = JSON.stringify(mock);
        sessionStorage.setItem("__devMockUser", devMock);
      }
      setUserData(JSON.parse(devMock));
      return;
    }

    /// ✅ 유저데이터 — 세션 우선, 없으면 자동 로그인(localStorage) 복원
    let localUserData = sessionStorage.getItem("userData");
    if (emptyCheck(localUserData)) {
      const persisted = localStorage.getItem("userData");
      if (!emptyCheck(persisted)) {
        sessionStorage.setItem("userData", persisted); // 기존 세션 기반 코드와 호환
        localUserData = persisted;
      }
    }
    if (emptyCheck(localUserData)) {
      if (
        window.location.pathname !== "/terms" &&
        window.location.pathname !== "/policy" &&
        window.location.pathname !== "/landing" &&
        window.location.pathname !== "/miadmin"
      ) {
        navigate("/"); // 로그인 페이지로 이동
      }
    } else {
      getUserData(localUserData);
    }
  }, []);

  /// ✅ 유저데이터 세팅
  const getUserData = async (localUserData) => {
    const userId = JSON.parse(localUserData);
    const resp = await login(userId);
    setUserData(resp[0]);
  };

  return (
    <UserContext.Provider
      value={{
        userData,
        setUserData,
        blockData,
        setBlockData,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
